export const toText = (v) => (typeof v === "string" ? v : v == null ? "" : String(v));


export const byLabelAsc = (a, b) =>
toText(a.label ?? a.id).localeCompare(toText(b.label ?? b.id), "en", { sensitivity: "base" });


// export const sortYearsDesc = (arr) => {
// // accepts ["2024", "2023", ...] or [{id,label}]
// const toNum = (x) => {
// const v = typeof x === "object" ? (x.id ?? x.value ?? x.label) : x;
// const n = parseInt(String(v), 10);
// return Number.isFinite(n) ? n : -Infinity;
// };
// return [...arr].sort((a, b) => toNum(b) - toNum(a));
// };

// Pick the year to sort by (max 4-digit year found in id/value/label)
// helper: extract a numeric year from id/label
const extractYear = (row) => {
  const s = String(row?.id ?? row?.label ?? "").trim();
  const hits = s.match(/\d{4}/g);
  return hits ? Math.max(...hits.map(Number)) : Number.NEGATIVE_INFINITY;
};

export const sortYearsDesc = (rows) =>
  [...rows].sort((a, b) => extractYear(b) - extractYear(a));
